/**
 * Select Country of Nationality
 * - user's country used to determine add card and add address formats
 */

import PropTypes from 'prop-types';
import React from 'react';

class CountrySelection extends React.Component {
    static propTypes = {
		supportedCountries: (props, propName, componentName) => {
			const supportedCountries = props[propName];

			// if we don't get the array of states we're expecting from Griffin, return an error
			if (!Array.isArray(supportedCountries) || (supportedCountries.length && !supportedCountries[0].countryCode)) {
				return new Error(
					`Invalid prop \`${propName}\` supplied to \`${componentName}\`. Please supply the array you get back from griffin.metadata.allSupportedCountries(), but map each supported country to an object: \`{ countryCode, countryName }.\``
				);
			}
			return null;
		},
		defaultValue: PropTypes.string,
		label: PropTypes.string,
		changeCountry: PropTypes.func.isRequired,
	};

    static defaultProps = {
        supportedCountries: [],
        changeCountry: () => {}
    };

    /**
	 * Set initial state to the first country in the list
	 */
    state = {
        selectedCountry: this.props.defaultValue || this.props.supportedCountries[0].countryCode
    };

    /**
	 * Select the first country in the list
	 */
    componentDidMount() {
		this.props.changeCountry(this.state.selectedCountry);
	}

    /**
	 * Handle changing the selected country
	 * - set the state
	 * - call parent's changeCountry() with the selected country
	 */
    handleChangeCountry = (event) => {
		let selectedCountry = event.target.value;
		this.setState({ selectedCountry });
		this.props.changeCountry(selectedCountry);
	};

    render() {

		// don't render anything if we don't get the correctly formatted list of countries
		if (!this.props.supportedCountries[0].countryCode) {
			return null;
		}

		return (
			<div className="ppvx_dropdown">
				<select
					id="countrySelection"
					className="ppvx_dropdown__control"
					value={this.state.selectedCountry}
					onChange={this.handleChangeCountry}
				>
					{this.props.supportedCountries.map(({ countryCode, countryName }) => (
						<option key={countryCode} value={countryCode}>{countryName}</option>
					))}
				</select>
				<label className="ppvx_dropdown__label" htmlFor="countrySelection">
					{this.props.label}
				</label>
			</div>
		);
	}
}

export default CountrySelection;
